import axios from 'axios'
import storage from '@/modules/storage'
import {
  clone,
  isObject,
} from 'lodash'

axios.defaults.timeout = 15000
export default class Http {
  constructor ({ modelUrlPrefix, timeout }) {
    this.client = axios.create({
      baseURL : process.env.VUE_APP_SP_TALK_API_URL + '/api/' + modelUrlPrefix,
      timeout
    })
    
    this.client.interceptors.request.use(this.embedToken)
  }

  embedToken (config) {
    const accessToken = storage.get('accessToken')
    config.headers['x-access-token'] = accessToken
    config.headers['Access-Control-Allow-Origin'] = '*'

    return config
  }

  create (param = null, data) {
    if (isObject(param)) {
      data = clone(param)
      param = null
    } else if (!isObject(data)) {
      data = {}
    }

    return this.client.post(param, data);
  }
}